import { useCallback, useEffect } from "react";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { useSelector } from "react-redux";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { Calendar, Views } from "react-big-calendar";
import { useLocalizer } from "setup/customHooks/Localizer";
import { getWeeklyMeetings, selectLoadingWeeklyMeetings, selectWeeklyMeetings } from "./WeeklyMeetingsSlice";
import { CalendarEventModel } from "services/api/cplapi/CPLAPI";
import { useNavigate } from "react-router-dom";
import "./CPLDashboard.scss";
import { CalendarEventTypes } from "global/enums";
import { eventRenderProps } from "app/modules/scheduling/calendar/components/CPLCalendar";
import WorkWeekView from "app/modules/scheduling/calendar/components/WorkWeekView";
import CalendarEventTypesKey from "app/modules/scheduling/calendar/components/CalendarEventTypesKey";

const WeeklyMeetings: React.FC = () => {
  const thunkDispatch = useThunkDispatch();
  const localizer = useLocalizer();
  const navigate = useNavigate();

  const loadingWeeklyMeetings = useSelector(selectLoadingWeeklyMeetings);
  const weeklyMeetings = useSelector(selectWeeklyMeetings);

  function onSelectEvent(event: CalendarEventModel) {
    switch (event.calendarEventTypeID) {
      case CalendarEventTypes.UserTask:
        navigate(`/UserTask/${event.userTaskID}/Details`);
        break;
      case CalendarEventTypes.Meeting:
        navigate(`/Meeting/${event.meetingID}/Details`);
        break;
    }
  }

  const slotGroupPropGetter = useCallback(
    () => ({
      style: {
        minHeight: 30,
      },
    }),
    []
  );

  useEffect(() => {
    thunkDispatch(getWeeklyMeetings());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="card dashboard-card">
      <div className="card-header">
        <div className="card-title">Weekly Meetings</div>
      </div>
      <div className="card-body">
        <ActivityIndicator isBusy={loadingWeeklyMeetings} busyMessage="Getting Weekly Meetings">
          <div className="wm-calendar-container">
            <Calendar
              dayLayoutAlgorithm={"no-overlap"}
              defaultView={Views.WORK_WEEK}
              events={weeklyMeetings}
              localizer={localizer}
              toolbar={false}
              onSelectEvent={(e) => onSelectEvent(e)}
              eventPropGetter={eventRenderProps}
              slotGroupPropGetter={slotGroupPropGetter}
              views={{
                month: false,
                week: false,
                work_week: WorkWeekView,
                agenda: false,
              }}
              className="rbc-dashboard-calendar"
            />
          </div>
          <div className="mt-4 fs-5">
            <CalendarEventTypesKey />
          </div>
        </ActivityIndicator>
      </div>
    </div>
  );
};

export default WeeklyMeetings;
